// productCollection.ts
//
// Single source of truth for the restaurant-products Firestore collection.
// The app migrated from the legacy `product` collection to the new
// `zapee_restaurant_products` collection (same flat schema: tittle,
// itemcategory, branch, category, subcategory, image, price, discount,
// stock, available, show, description …).
export const PRODUCT_COLLECTION = 'zapee_restaurant_products';
